module.exports = __webpack_public_path__ + "static/media/JamesBond.15ac1423.jpg";